/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Fairuse_Section1title2Inputs */

const id_misc_fairuse_section1title2 = /** @type {(inputs: Misc_Fairuse_Section1title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Pendahuluan`)
};

const ms_misc_fairuse_section1title2 = /** @type {(inputs: Misc_Fairuse_Section1title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Pengenalan`)
};

const da_misc_fairuse_section1title2 = /** @type {(inputs: Misc_Fairuse_Section1title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Introduktion`)
};

const de_misc_fairuse_section1title2 = /** @type {(inputs: Misc_Fairuse_Section1title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Einleitung`)
};

const en_us2_misc_fairuse_section1title2 = /** @type {(inputs: Misc_Fairuse_Section1title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Introduction`)
};

const es_es2_misc_fairuse_section1title2 = /** @type {(inputs: Misc_Fairuse_Section1title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Introducción`)
};

const es_mx2_misc_fairuse_section1title2 = /** @type {(inputs: Misc_Fairuse_Section1title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Introducción`)
};

const fil_misc_fairuse_section1title2 = /** @type {(inputs: Misc_Fairuse_Section1title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Panimula`)
};

const fr_misc_fairuse_section1title2 = /** @type {(inputs: Misc_Fairuse_Section1title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Introduction`)
};

const it_misc_fairuse_section1title2 = /** @type {(inputs: Misc_Fairuse_Section1title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Introduzione`)
};

const hu_misc_fairuse_section1title2 = /** @type {(inputs: Misc_Fairuse_Section1title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Bevezetés`)
};

const nl_misc_fairuse_section1title2 = /** @type {(inputs: Misc_Fairuse_Section1title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Inleiding`)
};

const no_misc_fairuse_section1title2 = /** @type {(inputs: Misc_Fairuse_Section1title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Innledning`)
};

const pl_misc_fairuse_section1title2 = /** @type {(inputs: Misc_Fairuse_Section1title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Wprowadzenie`)
};

const pt_br2_misc_fairuse_section1title2 = /** @type {(inputs: Misc_Fairuse_Section1title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Introdução`)
};

const pt_misc_fairuse_section1title2 = /** @type {(inputs: Misc_Fairuse_Section1title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Introdução`)
};

const ro_misc_fairuse_section1title2 = /** @type {(inputs: Misc_Fairuse_Section1title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Introducere`)
};

const fi_misc_fairuse_section1title2 = /** @type {(inputs: Misc_Fairuse_Section1title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Johdanto`)
};

const sv_misc_fairuse_section1title2 = /** @type {(inputs: Misc_Fairuse_Section1title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Introduktion`)
};

const vi_misc_fairuse_section1title2 = /** @type {(inputs: Misc_Fairuse_Section1title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Giới thiệu`)
};

const tr_misc_fairuse_section1title2 = /** @type {(inputs: Misc_Fairuse_Section1title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Giriş`)
};

const cs_misc_fairuse_section1title2 = /** @type {(inputs: Misc_Fairuse_Section1title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Úvod`)
};

const bg_misc_fairuse_section1title2 = /** @type {(inputs: Misc_Fairuse_Section1title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Въведение`)
};

const ru_misc_fairuse_section1title2 = /** @type {(inputs: Misc_Fairuse_Section1title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Введение`)
};

const uk_misc_fairuse_section1title2 = /** @type {(inputs: Misc_Fairuse_Section1title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Вступ`)
};

const ar_misc_fairuse_section1title2 = /** @type {(inputs: Misc_Fairuse_Section1title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. المقدمة`)
};

const hi_misc_fairuse_section1title2 = /** @type {(inputs: Misc_Fairuse_Section1title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. परिचय`)
};

const th_misc_fairuse_section1title2 = /** @type {(inputs: Misc_Fairuse_Section1title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. บทนำ`)
};

const ja_misc_fairuse_section1title2 = /** @type {(inputs: Misc_Fairuse_Section1title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. はじめに`)
};

const zh_cn2_misc_fairuse_section1title2 = /** @type {(inputs: Misc_Fairuse_Section1title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. 简介`)
};

const zh_hant1_misc_fairuse_section1title2 = /** @type {(inputs: Misc_Fairuse_Section1title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. 簡介`)
};

const ko_misc_fairuse_section1title2 = /** @type {(inputs: Misc_Fairuse_Section1title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. 소개`)
};

/**
* | output |
* | --- |
* | "1. Introduction" |
*
* @param {Misc_Fairuse_Section1title2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_fairuse_section1title2 = /** @type {((inputs?: Misc_Fairuse_Section1title2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Fairuse_Section1title2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_fairuse_section1title2(inputs)
	if (locale === "ms") return ms_misc_fairuse_section1title2(inputs)
	if (locale === "da") return da_misc_fairuse_section1title2(inputs)
	if (locale === "de") return de_misc_fairuse_section1title2(inputs)
	if (locale === "en-US") return en_us2_misc_fairuse_section1title2(inputs)
	if (locale === "es-ES") return es_es2_misc_fairuse_section1title2(inputs)
	if (locale === "es-MX") return es_mx2_misc_fairuse_section1title2(inputs)
	if (locale === "fil") return fil_misc_fairuse_section1title2(inputs)
	if (locale === "fr") return fr_misc_fairuse_section1title2(inputs)
	if (locale === "it") return it_misc_fairuse_section1title2(inputs)
	if (locale === "hu") return hu_misc_fairuse_section1title2(inputs)
	if (locale === "nl") return nl_misc_fairuse_section1title2(inputs)
	if (locale === "no") return no_misc_fairuse_section1title2(inputs)
	if (locale === "pl") return pl_misc_fairuse_section1title2(inputs)
	if (locale === "pt-BR") return pt_br2_misc_fairuse_section1title2(inputs)
	if (locale === "pt") return pt_misc_fairuse_section1title2(inputs)
	if (locale === "ro") return ro_misc_fairuse_section1title2(inputs)
	if (locale === "fi") return fi_misc_fairuse_section1title2(inputs)
	if (locale === "sv") return sv_misc_fairuse_section1title2(inputs)
	if (locale === "vi") return vi_misc_fairuse_section1title2(inputs)
	if (locale === "tr") return tr_misc_fairuse_section1title2(inputs)
	if (locale === "cs") return cs_misc_fairuse_section1title2(inputs)
	if (locale === "bg") return bg_misc_fairuse_section1title2(inputs)
	if (locale === "ru") return ru_misc_fairuse_section1title2(inputs)
	if (locale === "uk") return uk_misc_fairuse_section1title2(inputs)
	if (locale === "ar") return ar_misc_fairuse_section1title2(inputs)
	if (locale === "hi") return hi_misc_fairuse_section1title2(inputs)
	if (locale === "th") return th_misc_fairuse_section1title2(inputs)
	if (locale === "ja") return ja_misc_fairuse_section1title2(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_fairuse_section1title2(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_fairuse_section1title2(inputs)
	return ko_misc_fairuse_section1title2(inputs)
});
export { misc_fairuse_section1title2 as "misc.fairUse.section1Title" }